/* eslint-disable array-callback-return */
/* eslint-disable indent */
/* eslint-disable max-lines-per-function */
// Libraries
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FieldArray, reduxForm } from 'redux-form';
import { compose, bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { last } from 'lodash';
import { MAKER_CHECKER_EVENT_TYPES } from 'utils/constants/commonValues';
import { FormElems, Accordion, Alert } from '../../components/';
import { showLoader, hideLoader } from '../../redux/common/loader/loader.actions';
import {
    saveAndContinueRequest,
    resetSaveDataSuccessKey,
    submitStepFormRequest,
    fetchSurchargeSlabsRequest,
} from '../../containers/MerchantOnboard/redux/merchantOnBoard.actions';
import {
    updateSurchargeDataRequest,
    fetchSurchargeDetailsRequest,
    resetUpdateDataSuccessKey,
    addMerchantStepUpdateMakerRequest,
} from '../../containers/MerchantOnboard/redux/editMerchant/editMerchant.actions';
import { SUCCESS_MESSAGES } from '../../utils/constants/toastMessages';
import {
    getFormButtonText,
    getSchemeOptions,
    getSurchargeBankOptions,
    getWalletOptions,
} from '../../utils/helperMethods';
import CardSurcharge from './CardSurchargeSlab';
import UPISurcharge from './UpiSurchargeSlab';
import NBSurcharge from './NBSurchargeSlab';
import validate from './validator';
import ODSSurchargeSlab from './ODSSurchargeSlab';

// Component

// Actions

// Constant

// Validator

// Styles
import './surchargeTab.scss';

const SurchargeTab = ({
    merchantData,
    actions,
    sectionType,
    isEditMode,
    isViewMode,
    editData,
    data,
    name,
    nextPath,
    previousPath,
    history,
    handleSubmit,
    staticData,
    auth,
}) => {
    const {
        saveData,
        surchargeOptions,
        uniqueIdentifier: { uniqueId },
        timeline: { fields },
        formInProcess = [],
        paymentModes,
    } = merchantData;

    //  for current case let use use values such as

    const {
        payValues: { BANK_CODE },
    } = staticData;
    const { userDetails } = auth;
    const { updateData, sections } = editData;
    const { location } = history;

    const isUserTerminalState = !nextPath;

    const resetErrors = () => {
        if (isEditMode) {
            actions.resetUpdateDataSuccessKey();
        } else {
            actions.resetSaveDataSuccessKey();
        }
    };

    useEffect(() => {
        resetErrors();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * get form data
     */
    useEffect(() => {
        let req = {};
        if (isEditMode || isViewMode) {
            const merchantId = last(location.pathname.split('/'));
            req = {
                entityCode: merchantId,
                sectionType,
            };
        } else {
            req = {
                uniqueIdentifier: uniqueId,
                userId: userDetails.email,
                formType: 'merchantOnboardingForm',
                sectionType,
            };
        }

        actions.fetchSurchargeSlabsRequest(req);
    }, [
        actions,
        sectionType,
        userDetails,
        sections,
        isEditMode,
        isViewMode,
        location.pathname,
        formInProcess,
        uniqueId,
    ]);

    useEffect(() => {
        if (isEditMode || isViewMode) {
            const merchantId = last(location.pathname.split('/'));
            actions.fetchSurchargeDetailsRequest(
                {
                    entityCode: merchantId,
                },
                fields
            );
        }
    }, [actions, fields, isEditMode, isViewMode, location.pathname]);

    const handleFormSubmit = values => {
        let userOptions = [];
        const sections = Object.keys(values.feeConfigList);
        for (let i = 0; i < sections.length; i++) {
            if (
                sections[i] === 'Net-Banking' ||
                sections[i] === 'UPI' ||
                sections[i] === 'Wallets' ||
                sections[i] === 'AccountVerification' ||
                sections[i] === 'emi' ||
                sections[i] === 'ODS'
            ) {
                // eslint-disable-next-line no-loop-func
                values.feeConfigList[sections[i]].forEach(item => {
                    item.bankSlabs.forEach(bankSlab => {
                        const updatedBankSlab = { ...bankSlab };
                        updatedBankSlab.issuer = item.issuerId === 'all' ? null : item.issuerId;
                        delete updatedBankSlab.issuerId;
                        userOptions = [...userOptions, updatedBankSlab];
                    });
                });
            } else {
                // eslint-disable-next-line no-loop-func
                values.feeConfigList[sections[i]].forEach(item => {
                    item.bankSlabs.forEach(slab => {
                        const updatedSlab = { ...slab };
                        updatedSlab.cardType = item.cardType === 'all' ? null : item.cardType;
                        updatedSlab.cardCategory =
                            item.cardCategory === 'All Card Categories' ? null : item.cardCategory;
                        userOptions = [...userOptions, updatedSlab];
                    });
                });
            }
        }
        const feeConfigListMap = {};

        userOptions.forEach(user => {
            if (!feeConfigListMap[user.type]) {
                feeConfigListMap[user.type] = [];
            }
            feeConfigListMap[user.type].push(user);
            // delete user.type;
        });

        // eslint-disable-next-line guard-for-in
        for (const key in feeConfigListMap) {
            feeConfigListMap[key].forEach(item => {
                delete item.type;
            });
        }

        const request = {
            uniqueIdentifier: uniqueId,
            sectionType,
            userId: userDetails.email,
            formType: 'merchantOnboardingForm',
            data: {
                feeConfigListMap,
            },
        };

        if (isEditMode) {
            const merchantId = last(location.pathname.split('/'));
            const updateRequest = {
                entityCode: merchantId,
                feeConfigListMap,
            };
            const makerDetails = {
                makerId: auth.userDetails.email || '',
                idempotencyId: merchantId,
                eventType: MAKER_CHECKER_EVENT_TYPES.PRICING,
            };
            actions.addMerchantStepUpdateMakerRequest(updateRequest, sectionType, makerDetails);
        } else if (isViewMode) {
            onNext();
        } else {
            if (isUserTerminalState) {
                actions.submitStepFormRequest(request, sectionType);
            } else {
                actions.saveAndContinueRequest(request, sectionType);
            }
        }
    };
    const onNext = () => {
        actions.resetSaveDataSuccessKey();
        if (!isUserTerminalState) {
            history.push(nextPath);
        } else {
            history.push('/mob');
        }
    };

    const onBack = () => {
        actions.resetSaveDataSuccessKey();
        history.push(previousPath);
    };

    useEffect(() => {
        if (saveData.isSuccess && saveData.sectionType === sectionType) {
            toast.info(SUCCESS_MESSAGES.SAVE_DATA(name));
            onNext();
        }
        return () => {
            if (saveData.isSuccess && saveData.sectionType === sectionType) {
                actions.resetSaveDataSuccessKey();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saveData.isSuccess, saveData.sectionType]);

    useEffect(() => {
        if (updateData.isUpdated && updateData.sectionType === sectionType) {
            toast.info(SUCCESS_MESSAGES.UPDATE_MAKER_REQUEST_SUCCESS(name));
            onNext();
        }
        return () => {
            if (updateData.isUpdated && updateData.sectionType === sectionType) {
                actions.resetUpdateDataSuccessKey();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateData.isUpdated, updateData.sectionType]);

    const errorDetails = isEditMode ? updateData : saveData;

    const getAccordionTitle = section => {
        if (section === 'ODS') {
            return 'On Demand Settlement';
        } else if (section.length <= 3) {
            return section
                .split('-')
                .join(' ')
                .toUpperCase();
        }
        return section.split('-').join(' ');
    };

    return (
        <form className="surcharge-list-form" onSubmit={handleSubmit(handleFormSubmit)}>
            <div className="surcharge-tab card">
                <h2 className="tab-title">Pricing/Surcharge</h2>
                {errorDetails.error && errorDetails.error.errorMessage ? (
                    <Alert customClass="error-msg">{errorDetails.error.errorMessage}</Alert>
                ) : null}
                <div className="accordion-section">
                    {surchargeOptions.sections &&
                        // eslint-disable-next-line array-callback-return
                        surchargeOptions.sections.map((section, index) => {
                            if (surchargeOptions.slabs[section].length > 0) {
                                return (
                                    <>
                                        <Accordion
                                            key={section}
                                            customClass={`custom-accordion ${section}`}
                                            isOpened={index === 0}
                                            id={section}
                                            upperComponent={
                                                <h3 className="accordion-tile">{getAccordionTitle(section)}</h3>
                                            }
                                            lowerComponent={
                                                <AccLowerComponent
                                                    sectionData={surchargeOptions.slabs[section]}
                                                    sectionName={section}
                                                    bankOptions={getSurchargeBankOptions(
                                                        BANK_CODE,
                                                        surchargeOptions.paymentOptionList,
                                                        false
                                                    )}
                                                    walletOptions={getWalletOptions(
                                                        surchargeOptions.paymentOptionList,
                                                        false
                                                    )}
                                                    schemeOptions={getSchemeOptions(surchargeOptions.schemes)}
                                                    cardCategoriesOptions={surchargeOptions?.cardCategoriesOptions.map(
                                                        category => {
                                                            return {
                                                                label: category,
                                                                value: category,
                                                            };
                                                        }
                                                    )}
                                                    isViewMode={isViewMode}
                                                />
                                            }
                                        />
                                    </>
                                );
                            }
                        })}
                </div>
            </div>
            <div className="form-section action">
                {!isViewMode && (
                    <>
                        <FormElems.Button
                            buttonType="secondary"
                            text="BACK"
                            type="button"
                            handleClick={onBack}
                            id="back-btn"
                            customClass="back-btn"
                        />
                        <FormElems.Button
                            id="next-btn"
                            buttonType="primary"
                            text={getFormButtonText(isUserTerminalState)}
                        />
                    </>
                )}
            </div>
        </form>
    );
};

const AccLowerComponent = ({
    sectionData,
    sectionName,
    isViewMode,
    bankOptions,
    schemeOptions,
    walletOptions,
    cardCategoriesOptions,
}) => {
    const isNetBanking =
        sectionName === 'Net-Banking' ||
        sectionName === 'Wallets' ||
        sectionName === 'AccountVerification' ||
        sectionName === 'emi';

    const isODS = sectionName === 'ODS';

    const isUPI = sectionName === 'UPI';

    let renderComponent = CardSurcharge;

    if (isNetBanking) {
        renderComponent = NBSurcharge;
    } else if (isUPI) {
        renderComponent = UPISurcharge;
    } else if (isODS) {
        renderComponent = ODSSurchargeSlab;
    }

    return (
        <FieldArray
            name={`feeConfigList.${sectionName}`}
            id={`feeConfigList-${sectionName}`}
            component={renderComponent}
            bankOptions={bankOptions}
            walletOptions={walletOptions}
            schemeOptions={schemeOptions}
            cardCategoriesOptions={cardCategoriesOptions}
            props={{ sectionData, isViewMode, sectionName }}
        />
    );
};

SurchargeTab.propTypes = {
    data: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func,
    history: PropTypes.object,
    nextPath: PropTypes.string,
    previousPath: PropTypes.string,
    merchantData: PropTypes.object,
    actions: PropTypes.object,
    sectionType: PropTypes.string,
    name: PropTypes.string,
    isEditMode: PropTypes.bool,
    isViewMode: PropTypes.bool,
    editData: PropTypes.object,
    staticData: PropTypes.object,
    auth: PropTypes.object,
};

AccLowerComponent.propTypes = {
    sectionName: PropTypes.string,
    sectionData: PropTypes.object,
    bankOptions: PropTypes.object,
    schemeOptions: PropTypes.object,
    cardCategoriesOptions: PropTypes.array,
    isViewMode: PropTypes.bool,
    walletOptions: PropTypes.array,
};

const mapStateToProps = ({ auth, form, merchantData, editData, staticData }) => ({
    auth,
    form,
    merchantData,
    editData,
    staticData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            hideLoader,
            showLoader,
            saveAndContinueRequest,
            submitStepFormRequest,
            resetSaveDataSuccessKey,
            updateSurchargeDataRequest,
            addMerchantStepUpdateMakerRequest,
            fetchSurchargeDetailsRequest,
            resetUpdateDataSuccessKey,
            fetchSurchargeSlabsRequest,
        },
        dispatch
    ),
});

export default withRouter(
    compose(
        reduxForm({
            form: 'surcharge-form',
            validate,
            enableReinitialize: true,
        }),
        connect(mapStateToProps, mapDispatchToProps)
    )(SurchargeTab)
);
